import { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { IconButton, Tooltip } from '@material-ui/core';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { setOpenSnackbar } from '../../store/slices/snackbarSlice';
import ConfirmDialog from '../ConfirmDialog';
import useVrackApi from '../../hooks/useVrackApi';

DeleteVmTemplateButton.propTypes = {
  type: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  vmTemplate: PropTypes.string,
  disabled: PropTypes.bool,
  onDeleted: PropTypes.func
};

DeleteVmTemplateButton.defaultProps = {
  type: 'text',
  variant: 'contained',
  color: 'primary'
};

export default function DeleteVmTemplateButton({
  type,
  variant,
  color,
  vmTemplate,
  disabled,
  onDeleted
}) {
  const dispatch = useDispatch();
  const userIdentity = useSelector((state) => state.identity.value);
  const [confirmDialogOpen, setDialogOpen] = useState(false);
  const openSnackbar = (payload) => dispatch(setOpenSnackbar(payload));
  const { fetchData: vrackApiVMTemplateDelete } = useVrackApi('delete', `/racks/vm/${vmTemplate}`);

  const handleDialogCancel = () => {
    setDialogOpen(false);
  };
  const handleDialogConfirm = async () => {
    await deleteVmTemplate(vmTemplate);
    setDialogOpen(false);
  };
  const handleDialogOpen = (event) => {
    event.stopPropagation();
    setDialogOpen(true);
  };

  const deleteVmTemplate = async (vmTemplate) => {
    console.debug(`Deleting VM Template: ${vmTemplate}`);

    await vrackApiVMTemplateDelete({
      data: {
        identity: userIdentity
      }
    })
      .then((response) => {
        console.debug(`successfully deleted template: ${JSON.stringify(response.data)}`);
        openSnackbar({
          message: 'vm template delete request successful'
        });
        onDeleted?.();
      })
      .catch((error) => {
        console.error(error.message);
        openSnackbar({
          message: `template delete request failed: ${error.response.data.message}`,
          severity: 'error'
        });
      });
  };
  return (
    <>
      <ConfirmDialog
        title={`Delete VM Template (${vmTemplate})?`}
        content="Are you sure you wish to delete the VM template?"
        onCancelHandler={handleDialogCancel}
        onConfirmHandler={handleDialogConfirm}
        isOpen={confirmDialogOpen}
      />
      {type === 'icononly' && (
        <Tooltip title="Delete VM Template" placement="top">
          <IconButton
            variant={variant}
            onClick={handleDialogOpen}
            disabled={disabled}
            color={color}
          >
            <DeleteOutlineIcon />
          </IconButton>
        </Tooltip>
      )}
    </>
  );
}
